import React from 'react';


export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {
            return (
                <div>
                    {props.children}
                </div>
            )
        },
        namespace: namespace,
        id: 'form-empty',
        hideInMenu: true,
        version: 1,
    }
}
